export const zIndex = {
  popup: 99,
  aboveHeader: 6,
  header: 5,
  belowHeader: 4,
  aboveInput: 3,
  input: 2,
  under: -1,
};
